import { ActionItemButton } from '@components/button/action-item-button';
import { MenuItem } from '@headlessui/react';

import { MenuVenueOption, MenuVenueRoutes } from '../menu-venue.type';

export const MenuDesktopOptions = ({
  menuOptions,
  handleClickClub,
}: {
  menuOptions: MenuVenueOption[];
  handleClickClub: (id: MenuVenueRoutes) => void;
}) => (
  <>
    {menuOptions.map((option) => (
      <MenuItem key={`option-menu-desktop-${option.id}`}>
        {({ focus }) => (
          <ActionItemButton active={focus} onClick={() => handleClickClub(option.id)} text={option.label} />
        )}
      </MenuItem>
    ))}
  </>
);
